import { take, map } from 'rxjs/operators';
import { Intervallo, IIntervallo } from 'app/model/ambulatorio';
import { Giorno } from 'app/model/time';
import { NgbTimeStruct, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
	selector: 'app-ambulatorio',
	templateUrl: './ambulatorio.html',
	styleUrls: ['./ambulatorio.css']
})
export class AmbulatorioComponent {
	// BAU!
	//       __
	//  (___()'`;
	//  /,    /`
	//  \\"--\\
	@ViewChildren(NgbTimepicker, { read: ElementRef })
	set picker(value: QueryList<ElementRef>) {
		// Diciamo grazie ai tizi di bootstrap.
		for (let el of value.map(c => c.nativeElement as HTMLElement)) {
			let list = el.querySelectorAll(".btn-link");
			for (var i = 0; i < list.length; i++) {
				(list.item(i) as HTMLElement).tabIndex = -1;
			}
		}
	}

	private _ambulatorio: Giorno[];

	@Input()
	set ambulatorio(value: Giorno[]) {
		this._ambulatorio = value;
		this.peek = Observable.combineLatest(value).pipe(
			map(() => true),
			take(1)
		).toPromise();
	}

	get ambulatorio(): Giorno[] {
		return this._ambulatorio;
	}

	peek: Promise<boolean>;

	giorni = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

	correct = true;
	intervalloSelezionato: Intervallo;
	giorno: Giorno;

	select(giorno: Giorno, intervallo: Intervallo) {
		this.intervalloSelezionato = intervallo;
		this.giorno = giorno;
	}

	hide() {
		this.intervalloSelezionato = null;
		this.giorno = null;
	}

	delete(intervallo: Intervallo) {
		this.giorno.delete(intervallo);
		this.hide();
	}

	aggiorna(inizio: NgbTimeStruct, fine: NgbTimeStruct) {
		const interval: IIntervallo = { inizio: inizio, fine: fine };
		this.correct = this.check(interval);
		if (this.correct) {
			this.intervalloSelezionato.update(interval);
		}
	}

	check(intervallo: IIntervallo) {
		return (intervallo.inizio.hour < intervallo.fine.hour) ||
			(
				(intervallo.inizio.hour === intervallo.fine.hour) &&
				(intervallo.inizio.minute < intervallo.fine.minute)
			);
	}
}



// WEBPACK FOOTER //
// ./src/app/impostazioni_agenda/ambulatorio/ambulatorio.ts